import { NavLink } from "react-router-dom";
import { message } from "antd";

import AppsSharpIcon from '@mui/icons-material/AppsSharp';
import DescriptionIcon from '@mui/icons-material/Description';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import { ENABLED_MOBILE_ROUTES } from './enabledRoutes';
import './BottomTabBar.css';

const tabClass = ({ isActive }) =>
    isActive ? "mobile-tabbar-item active" : "mobile-tabbar-item";

/* Gated tabs render as buttons rather than links so a long-press
   "open in new tab" can't walk past the gate. */
const TabItem = ({ to, icon, label }) => {
    const contents = (
        <>
            {icon}
            <span className="mobile-tabbar-label">{label}</span>
        </>
    );

    if (to && ENABLED_MOBILE_ROUTES.includes(to)) {
        return (
            <NavLink to={to} className={tabClass} end>
                {contents}
            </NavLink>
        );
    }

    return (
        <button
            type="button"
            className="mobile-tabbar-item"
            onClick={() => message.info('Coming soon')}
        >
            {contents}
        </button>
    );
};

const BottomTabBar = () => {
    return (
        <nav className="mobile-tabbar">
            <TabItem
                to="/dashboard/stats"
                icon={<AppsSharpIcon className="mobile-tabbar-icon" />}
                label="Home"
            />
            <TabItem
                to="/dashboard/applications"
                icon={<DescriptionIcon className="mobile-tabbar-icon" />}
                label="Applications"
            />
            <TabItem
                to="/dashboard/loans"
                icon={<CreditScoreIcon className="mobile-tabbar-icon" />}
                label="Loans"
            />
            {/* The More sheet comes later. */}
            <TabItem
                icon={<MoreHorizIcon className="mobile-tabbar-icon" />}
                label="More"
            />
        </nav>
    );
};

export default BottomTabBar;
